import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si recién arranco la carrera o si ya llevo años?',
  a: 'Es el mejor momento para arrancar con estructura en cualquier etapa. Si recién empezás, construís bien desde el día uno. Si ya llevás años, ordenás, corregís errores y dejás de perder materias por métodos que no funcionan.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Apenas confirmás el pago recibís el acceso de forma inmediata. Todo en PDF, listo para abrir desde el celular, tablet o computadora. Sin esperas, sin instalaciones, sin programas raros.'
}, {
  q: '¿Es realmente para el mercado argentino?',
  a: 'Totalmente. Está diseñado pensando en nuestra forma de cursar, nuestra carga horaria, la presión de trabajar y estudiar al mismo tiempo y la realidad del sistema universitario público y privado de Argentina.'
}, {
  q: '¿Funciona para cualquier carrera?',
  a: 'Sí. Los métodos de retención, organización y manejo de ansiedad funcionan para Derecho, Medicina, Ingeniería, Económicas, Humanidades y cualquier otra carrera. No vendemos contenido de materias, vendemos el sistema para aprender cualquier contenido.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días sin preguntas. Si abrís los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y te lo devolvemos el 100%. Sin formularios, sin drama, sin vueltas.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-53" data-mp="16o79sn0c22p2">
      <div className="mx-auto max-w-3xl px-5 py-20 pt-[32px] pb-[0px]" data-id="element-54" data-mp="rz2tjbd3m8jl">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-55" data-mp="s0vzspjsuqr2">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-56" data-mp="ixuuus6o75oz">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-57" data-mp="2pmde26rpfkte" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03]" data-id="element-58" data-mp="2pnoogpfnnqth">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-59" data-mp="2fxdb6ca3059x">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold" data-id="element-60" data-mp="2azbt9uoe6c01" /> : <PlusIcon className="h-5 w-5 shrink-0 text-verde-soft" data-id="element-61" data-mp="38l94d70fzf1y" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-62" data-mp="33mo5pc0u93fm">
                  <div className="overflow-hidden" data-id="element-63" data-mp="2ylic7bzctc51">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-64" data-mp="2umhtruksgbik">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}